if(!customElements.get("department-menu")) {
    class DepartmentMenu extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {

            // START SELECTORS
            this.departments =JSON.parse( this.dataset.departments);
            this.sub = this.dataset.sub;
            this.button = this.querySelector("[data-trigger]");
            this.menu = this.querySelector("[data-menu]");
            this.departmentRow = this.querySelector("[data-department]");
            this.subDepartmentRow = this.querySelector("[data-subdepartment]");
            this.departmentDiv = this.querySelector("[data-department-list]");
            this.subdepartmentDiv = this.querySelector("[data-subdepartment-list]");
            this.moreButton = this.querySelector("[data-more-button]");
            this.elementClose = this.querySelector("[data-close]");
            // END SELECTORS

            // START VARIABLES
            this.isMobile = window.innerWidth <= 768;
            this.useIcon = true;
            this.selectedDepartment = '';
            // END VARIABLES
            this.setupDepartments();

            this.setupEventListeners();
        }
        setupEventListeners() {
            if (this.isMobile) { // mobile event listeners
                this.button.addEventListener("click", (event) => {
                    event.preventDefault();
                    this.toggleMenu(false);
                })
                if (this.sub) {
                    this.departmentDiv.addEventListener("click", (event) => {
                        const selectedElement = event.target;
                        if (selectedElement.matches("button")) {
                            if (selectedElement != this.selectedDepartment && this.selectedDepartment != '') {
                                this.selectedDepartment.classList.remove('hovered');
                            }
                            this.selectedDepartment = selectedElement;
                            this.mouseMobileEnterButton(selectedElement);
                        }
                    })
                }
                this.elementClose.addEventListener("click", (event) => {
                    this.toggleMenu(true);
                }); 
            } else { // desktop event listeners
                this.button.addEventListener("mouseover", (event) => {
                    event.preventDefault();
                    this.toggleMenu(false);
                })
                if (this.sub) {
                    this.departmentDiv.addEventListener("mouseover", (event) => {
                        const selectedElement = event.target;
                        if (selectedElement.matches("button")) {
                            if (selectedElement != this.selectedDepartment && this.selectedDepartment != '') {
                                this.selectedDepartment.classList.remove('hovered');
                            }
                            this.selectedDepartment = selectedElement;
                            this.mouseDesktopEnterButton(selectedElement)
                        }
                    })
                }
                this.addEventListener("mouseleave", (event) => {
                    this.mouseOutDesktop();
                });

            }
        }
        setupDepartments () {
            let buttons = '';
            this.departments.forEach(department => {
                buttons += this.constructButtons(department.name, department.url,department.icon);
            });
            this.departmentDiv.innerHTML = buttons;
        }

        constructButtons (title, url, image = null) { // foreach construction function
            let isImage = '';
            let html = '';
            if (this.useIcon) {
                isImage = (image) ? '<img src="'+ image +'" class="col-md-2 col-2" />' : '';
            }
            if (this.sub == "true") {
                html =
                    '<button data-title="' + title + '" data-url="'+ url +'" class="btn btn-light d-flex align-items-center justify-content-between w-100 p-4 border rounded shadow-sm my-2" style="background-color:#f7f8f9">' + 
                    isImage +
                    '<div class="col-8 d-flex align-items-center">' +
                        '<div class="text-start">' +
                        '<div class="fw-semibold"><div class="lead">' + title + '</div></div>' +
                        '</div>' +
                    '</div>' +
                    '<span class="text-secondary">' +
                    '<i class="bi bi-chevron-right"></i>' +
                    '</span>' +
                    '</button>';
            } else {
                html =
                    '<a href="' + url + '" data-title="' + title + '" data-url="' + url + '" ' +
                    'class="btn btn-light w-100 p-0 border rounded-3 shadow-sm my-3 product-link">' +

                        '<div class="d-flex align-items-center gap-4 p-4">' +

                            isImage +

                            '<div class="flex-grow-1 text-start">' +
                                '<div class="fw-semibold product-title">' + title + '</div>' +
                                '<div class="product-subtitle">Ver productos de la marca</div>' +
                            '</div>' +

                            '<div class="product-arrow">' +
                                '<i class="bi bi-chevron-right"></i>' +
                            '</div>' +

                        '</div>' +
                    '</a>';


            }
            return html;
        }

        constructSubdepartments (title, ref = '#') {
            const html =
                '<div class="col-6 col-md-4 mb-5">' +
                    '<a href="' + ref + '" class="text-decoration-none">' +
                        '<div class="card border-0 shadow-sm h-100 p-3 hover-shadow">' +
                            
                            // Elemento visual decorativo
                            '<div class="d-flex justify-content-center mb-3">' +
                                '<div class="rounded-circle bg-light d-flex justify-content-center align-items-center" ' +
                                    'style="width:60px;height:60px;">' +
                                    '<i class="bi bi-grid fs-3 text-secondary"></i>' +
                                '</div>' +
                            '</div>' +

                            '<h6 class="text-center fw-semibold mb-2 text-dark">' + title + '</h6>' +

                            '<div class="text-center text-secondary small">' +
                                'Ver más' +
                                '<i class="bi bi-chevron-right ms-1"></i>' +
                            '</div>' +
                        '</div>' +
                    '</a>' +
                '</div>';
            return html;
        }
        toggleMenu(option) {
            if (this.menu) {
                this.menu.hidden = option;
            }
        }
        // Subcategory hovered function to create those elements
        mouseDesktopEnterButton(hoveredButton) {
            let subDepartments = '';
            const departmentTitle = hoveredButton.dataset.title;
            const departmentUrl = hoveredButton.dataset.url;
            const departmentObject = this.getDataFromDepartmentName(departmentTitle);
            if (departmentObject) {
                departmentObject.subcategories.forEach (sub => {
                    subDepartments += this.constructSubdepartments(sub.name, sub.url);
                })
            }
            this.subdepartmentDiv.innerHTML= subDepartments;
            // falta agregar UI update
            hoveredButton.classList.add('hovered');
            this.querySelector("[data-department-title]").textContent = departmentTitle;
            this.querySelector("[data-more-button]").href = departmentUrl;
        };
        mouseMobileEnterButton(clickedButton) {
            let subDepartments = '';
            const departmentTitle = clickedButton.dataset.title;
            const departmentUrl = clickedButton.dataset.url;
            const departmentObject = this.getDataFromDepartmentName(departmentTitle);
            if (departmentObject) {
                departmentObject.subcategories.forEach (sub => {
                    subDepartments += this.constructSubdepartments(sub.name, sub.url);
                })
            }
            if (this.departmentRow.style.flexBasis != "20%") {
                this.departmentRow.style.flexBasis = "20%";
                this.departmentDiv.style.removeProperty("max-height");
                this.subDepartmentRow.style.display = "block";
            }
            this.subdepartmentDiv.innerHTML= subDepartments;
            clickedButton.classList.add('hovered');
            this.querySelector("[data-department-title]").textContent = departmentTitle;
            this.querySelector("[data-more-button]").href = departmentUrl;
        }

        mouseOutDesktop() {
            if (this.subdepartmentDiv) {
                this.subdepartmentDiv.innerHTML= '';
            }
            this.toggleMenu(true);
        }
        // searches from metaobject the department name, if found, then return whole department object
        getDataFromDepartmentName (name) {
        let object = null;
        this.departments.forEach(entry => {
            if (entry.name == name) {
            object = entry;
            }
        });
        return object;
        };
    }
    customElements.define("department-menu", DepartmentMenu);

}